module.exports = __webpack_public_path__ + "img/d03d6c0.jpg";